exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pegasus-tabs .v-tab[data-v-44cef723]{background:#f5f5f5;color:#555;font-weight:600}.pegasus-tabs .v-tab--active[data-v-44cef723]{background:#1976d2;color:#fff}", ""]);

// exports
